export default function cardColor({ taskType, emailMessage }) {
  if (taskType && taskType.name === 'handle-message') {
    if (emailMessage.senderType === 'airline')
      return { border: '1px solid blue', borderBottom: 'none' };
    if (emailMessage.senderType === 'pax')
      return { border: '1px solid green', borderBottom: 'none' };
  }
}



// WEBPACK FOOTER //
// ./src/component/TasksListComponents/cardColor.js